import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { EIMLTypeSubstratMineral } from 'src/app/domain/IML/enum/type-substrat-mineral';
import { EIMLTypeSubstratVegetal } from 'src/app/domain/IML/enum/type-substrat-vegetal';
import { Substrat } from 'src/app/domain/IML/substrat';
import { StringConverter } from '../string-converter';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-iml-substrat-box',
    templateUrl: './iml-substrat-box.component.html',
    styleUrls: ['./iml-substrat-box.component.scss']
})
export class IMLSubstratBoxComponent implements OnInit {
    IsY2FarControl = new UntypedFormControl('', Validators.compose([
        Validators.pattern(/^(\d{7})?$/)]));

    IsX2FarControl = new UntypedFormControl('', Validators.compose([
        Validators.pattern(/^(\d{6})?$/)]));

    public model: Substrat = new Substrat();

    public SubstratMineralList: string[] =
        Object.values(EIMLTypeSubstratMineral)
            .filter(x => !isNaN(Number(x)))
            .map((x: EIMLTypeSubstratMineral) => StringConverter.getIMLSubstratMineralName(x));
    public SubstratVegetalList: string[] =
        Object.values(EIMLTypeSubstratVegetal)
            .filter(x => !isNaN(Number(x)))
            .map((x: EIMLTypeSubstratVegetal) => StringConverter.getIMLSubstratVegetalName(x));

    get CanAdd() {
        return true;
    }

    constructor(
        public dialogRef: MatDialogRef<IMLSubstratBoxComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Substrat) {
        // if (data)
        //     this.model = Object.assign({}, data);
        // else {
        this.model = data;
        // }
    }

    ngOnInit(): void {
        this.IsX2FarControl.markAsTouched();
        this.IsY2FarControl.markAllAsTouched();
    }

    onKeyUpEventForGPSX(event: any) {
        this.model.GPSPosition.L93X = Number(event.target.value);
    }

    onKeyUpEventForGPSY(event: any) {
        this.model.GPSPosition.L93Y = Number(event.target.value);
    }

    onCancel(): void {
        this.dialogRef.close(null);
    }

    onConfirm() {
        this.dialogRef.close(this.model);
    }
}
